import { SolidifyableData } from "../../../../../core/data/SolidifyableData";
/**
 * OperatorData.ts
 */
export class OperatorData extends SolidifyableData {
    solidify() {
        super.solidify();
        if (this.dataExists(this.data)) {
            this.solidifyError();
        }
    }
    solidifyError() {
        let detailsData = this.data.getDataObject(OperatorData.DETAIL);
        if (detailsData) {
            this.details = detailsData;
        }
    }
    getDetails() {
        return this.details;
    }
}
OperatorData.DETAIL = "detail";
//# sourceMappingURL=OperatorData.js.map